// project import
import admin from './admin';
import menu from './menu';

// ==============================|| MENU ITEMS ||============================== //

export const navigation = {
  items: [admin, menu]
};
